import { Box, Button, Select, Typography, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

export const Models = styled(Box)({
	...flexMixin({ justify: 'flex-start', direction: 'column', gap: 20 }),
	width: '100%',
	height: '100%',
});

export const TemplateName = styled(Typography)({
	fontWeight: 700,
	fontSize: '16px',
});

export const ModelSelect = styled(Select)({
	width: '70%',
});

export const SaveButton = styled(Button)({
	marginTop: '24px',
	padding: '12px 16px',
	borderRadius: '16px',
});

export const LoaderBox = styled(Box)({
	...flexMixin({}),
	height: '100%',
	width: '100%',
	marginBottom: '160px',
});
